<div class="dropdown dropdown-container">
  <div id="{{title}}-btn" [ngClass]="[alignment,
  (showCaret ? '' : 'remove-caret'),
  (style === DROPDOWN_STYLES.FILLED ? 'btn-' : style === DROPDOWN_STYLES.STROKE ? 'btn-outline-' : 'btn-link text-') + type,
  (iconClass ? ( showIconAndTitle ) ? 'icon-title-dropdown remove-caret' : 'icon-dropdown remove-caret' : '' ),
  (disabled ? 'disable-click' : '')]" class="btn w-100 dropdown-toggle" data-toggle="dropdown" (click)="toggleOptions(this)">
    <ng-container *ngIf="!iconClass">
      {{title}}
    </ng-container>
    <ng-container *ngIf="iconClass && !showIconAndTitle">
      <i id="{{title}}-icon" class="icon-dropdown {{iconClass}}" aria-hidden="true"></i>
    </ng-container>
    <ng-container *ngIf="iconClass && showIconAndTitle" class="icon-with-title-container">
      <i id="{{title}}-icon" class="{{iconClass}}" aria-hidden="true"></i>
      <span>{{ title }}</span>
    </ng-container>
  </div>
  <div id="{{title}}" class="dropdown-menu dropdown-options" [ngClass]="dropdownOptionsPosition ? dropdownOptionsPosition : ''">
    <beaconstac-options (valueChange)="setValue($event)"
                        [listItems]="listItems"
                        [optionsPosition]="dropdownOptionsPosition"
                        [maxHeight]="'200px'"
                        [optionValueField]="optionValueField"
                        [highlightSelectedValue]="false"
                        [optionLabelField]="optionLabelField"></beaconstac-options>
  </div>
</div>
